import { Component, Inject, OnInit } from '@angular/core';

import { config } from '../../config/index';
import { contactViewPipe } from './pipes/phone-view.pipe';

import { SharedService } from './shared/services/shared.service';

import '../../node_modules/@mobiscroll/angular/dist/css/mobiscroll.angular.min.css';
import '../../node_modules/swiper/css/swiper.min.css';

@Component({
  selector: 'my-app',
  template: require('./virtual-consultation-app.component.html'),
  styles: [require('./virtual-consultation-app.component.less')],
  preserveWhitespaces: true,
  providers: [contactViewPipe]
})
export class VirtualCOnsultationAppComponent implements OnInit {

    subscriptionDetails:any = [];
    favIcon:any;
    stripeKey: any = config.StripeKey;
    isMobile:boolean = false;
    restrictAccess: boolean = false ;
    practice_phone: any;
    practice_email: any;
    countryCode: any;

    constructor(
      private _sharedService:SharedService,
      private contactViewPipe: contactViewPipe,
      @Inject('utilService') private utilService: any
    ) {
      this.utilService.restrictAccess.subscribe(this.updateRestrictAccess);
    }

    updateRestrictAccess = (settings: any) => {
      if (settings?.restrict) {
        this.restrictAccess = true;
        this.practice_phone = settings.phone;
        this.practice_email = settings.email;
        this.countryCode = settings.country_key;

        if (this.practice_phone && (this.countryCode === 'US' || this.countryCode === 'CA')) {
          this.practice_phone = this.contactViewPipe.transformNational(this.practice_phone, this.countryCode);
        }
      }
    }


    onDeactivate() {
      document.body.scrollTop = 0;
    }

    ngOnInit() {

      this.isMobile = this._sharedService.isMobileOrTabletDevice();

        // remove zoom on orientation change
        window.onorientationchange = () => {
          (<HTMLElement>document.activeElement).blur();
        };
    }

}
